import styled from 'styled-components'

const WykazJednostekSkonsolidowaneStyle = styled.div `
  .site-header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 12px 8px 12px;

    button {
      min-width: 132px;
    }
  }

  .container {
    padding: 0 12px;
  }

  .subsection {
    width: 100%;
    display: grid;
    padding: 0 24px;
  }

  .list-header {
    width: 100%;
    padding-left: 24px;
  }

  .header {
    width: 100%;
    height: 36px;
    background: ${props => props.theme.black4onBlack4};
    padding: 12px 20px 10px;
    font-family: 'Ubuntu';
    font-size: 11px;
    color: ${props => props.theme.black38};
    margin: 0 0 12px 0;
  }

  .numericField {
    width: 72px;
  }

  .dates {
    width: 100%;
    display: grid;
    grid-template-columns: 148px 12px 148px 1fr;
    grid-column-gap: 16px;
  }

  .dates-header {
    display: grid;
    grid-template-columns: 172px 144px 1fr;
  }

  .oneLine {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .textarea {
    width: 100%;
    display: grid;
    min-height: 56px;
  }

  .siedzibaR2Wrapper .details {
    margin: 0;
    padding: 16px 24px;
  }

  .siedzibaR2Wrapper .siedzibaR2 {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto;
    grid-row-gap: 24px;
  }

  .siedzibaR2Wrapper .siedzibaR2 .wariantSiedziby {
    margin-top: -8px;
  }

  .siedzibaR2Wrapper .siedzibaR2Polska {
    display: grid;
    grid-template-rows: auto auto auto;
    grid-row-gap: 24px;
  }

  .siedzibaR2Wrapper .siedzibaR2Polska .firstRow {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    grid-column-gap: 16px;
  }

  .siedzibaR2Wrapper .siedzibaR2Polska .secondRow {
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr);
    grid-column-gap: 16px;
  }

  .siedzibaR2Wrapper .siedzibaR2Polska .thirdRow {
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr);
    grid-column-gap: 16px;
  }

  .siedzibaR2Wrapper .siedzibaR2Zagraniczna {
    display: grid;
    grid-template-rows: auto auto;
    grid-row-gap: 24px;
  }

  .siedzibaR2Wrapper .siedzibaR2Zagraniczna .secondRow {
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(0, 1fr) minmax(0, 1fr);
    grid-column-gap: 16px;
  }

  .siedzibaR2Wrapper .siedzibaR2Zagraniczna .thirdRow {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 2fr) minmax(0, 1fr);
    grid-column-gap: 16px;
  }
`
export default WykazJednostekSkonsolidowaneStyle
